import React from 'react';
import { DSOStoreHeaderProps } from './DSOStoreHeader.types';
import * as S from './DSOStoreHeader.styles';
import { DSOSearchField } from '../DSOSearchField';

const DSOStoreHeader: React.FC<DSOStoreHeaderProps> = ({
  title = 'Align Store',
  showSearchBar = true,
}) => {
  return (
    <S.StoreHeader>
      <S.StoreTitle>{title}</S.StoreTitle>
      {showSearchBar && (
        <S.SearchContainer>
          <DSOSearchField />
        </S.SearchContainer>
      )}
    </S.StoreHeader>
  );
};

export default DSOStoreHeader;
